import Styles from './Header.module.scss'
import cx from 'classnames'

import { HeaderProps } from './Types'

const Header = ({ children, width, className, style }: HeaderProps) => {
  return (
    <div className={cx(Styles.th, className)} style={{ width, ...style }}>
      <span className={Styles.label}>{children}</span>
    </div>
  )
}

export { Header }
